import { UserContext } from "../App"
import { InputForm } from "../atoms/input"
import { VerticalLayout } from "../components/layout"
import { SettingHeader } from "./SettingHeader"
import { useContext, useState } from "react"

export const ThemeTitleContent = function ({setTitleContent, titles}) {
    const userInformation = useContext(UserContext)
    const isPublic = userInformation.account_type === 1
    const [employeeTitle, setEmployeeTitle] = useState({"employee_text": ""});

    function updateTitles(val) {
        setEmployeeTitle(val);
        setTitleContent(val);
    }

    return (
        <VerticalLayout className="title-theme-creator" style={{width:"50%"}}>
            <SettingHeader
                title="Titel"
                description="Pas titels aan van de applicatie"
            />
            <div className="input-theme-container" style={{padding: "0px 1rem"}}>
                <InputForm title="Naam voor cursisten" placeholder={isPublic ? "Leads" : "Werknemers"} typeInput={(val) => updateTitles({"employee_text": val})} value={titles.employee_text}/>
            </div>
        </VerticalLayout>
    )
}